import React, {useEffect, useState} from "react";
//import banner from "../../images/aiblack.jpeg";
import Footer from "../../components/foot";
import Loading from "../../components/loading";
import "./index.css";
import jsondata from "./data.json"


function MyBlogPage(){

	let [data, setData] = useState([]); //empty data
	let [scope, setScope] = useState("");
	let [ready, getReady] = useState(false); //to know when data is ready...	

	useEffect(()=>{
		getReady(false);

		setData(scope === "" ? jsondata : jsondata.filter((obj)=>obj.subject === scope))
		getReady(true)
	}, [scope])

	return(
		<React.Fragment>

		<header id='bloghead'>

			<h2 data-aos="fade-down-right" data-aos-easing="linear" data-aos-duration="500"> Hi!, My Name is <span>Ibrahim B. Oduola</span> </h2>

			<h1 data-aos="fade-right" data-aos-easing="linear" data-aos-duration="800"> I learn & I Write </h1>

			<p data-aos="fade-down" data-aos-easing="linear" data-aos-duration="500">
				With the remarkable volume of information available today, it is getting harder and harder to distinguish
				the facts from falsehood and as people often say "we are what we read". Someone's biases (unintentional or not)
				influences your reasoning and you (we) have no clue. It is therefore important to think through the materials at
				hand and come up with an acceptable stand point to view the issue at hand. 
			</p> 
			<p> 
				My goal is constantly learn (and unlearn) about ideas and things I find interesting (technology, maritime industry and the 
				world in general) and share (by writing) insights that is helpful to me and can be of help to you too.
			</p>

			<div className='btn-gp'>
				<a href="/service/" className="sharp"> FreeLancing Service </a>
				<a href="/#contact-me" className="sharp"> Contact Ibrahim </a>
				<a href="/about/" className="sharp"> About Ibrahim </a>
			</div>

		</header>

		<main id="blogbody">

			<section className='nav-area' >
					<button onClick={()=>setScope("")} className={ scope === "" ? "spoton" : ""} > All </button>
					<button onClick={()=>setScope("ai")} className={ scope === "ai" ? "spoton" : ""} > Machine Learning </button>
					<button onClick={()=>setScope("maritime")} className={ scope === "maritime" ? "spoton" : ""} > Maritime Industry </button>

			</section>

			<section className='reader'>
				
				{
					!ready ? <Loading /> : data.map((article)=>{

						return(

							<article key={article.id} data-aos="zoom-in-up" data-aos-duration="800">
								<h3> {article.topic} </h3>
								<img src={article.image} alt={article.topic} loading="lazy" />
								<div className="petty">
									<p> {article.readtime} min read </p>
									<p> {article.published} </p>
								</div>

								<p className='context'>
									{article.body}...
								</p>
								<center><a href={article.link} target="_blank" rel="noreferrer" > continue reading... </a></center>
							</article>


						)
					})
				}
				
			</section>
		</main>

		<Footer />

		</React.Fragment>

		)
};

export default MyBlogPage;